"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Normalizer =
/** @class */
function () {
  function Normalizer(cache) {
    this.cache = cache;
  }

  Normalizer.prototype.idToRecordKey = function (id, type) {
    return (type + "_" + id).toLowerCase();
  };

  Normalizer.prototype.recordKeyToData = function (key) {
    var _a = key.split('_'),
        type = _a[0],
        id = _a[1];

    return {
      id: id,
      type: type
    };
  };

  Normalizer.prototype.parseRelationships = function (rel) {
    var _this = this;

    var rec = rel.data;
    if (!rec) return;

    if (Array.isArray(rec)) {
      return rec.map(function (_a) {
        var id = _a.id,
            type = _a.type;
        return _this.idToRecordKey(id, type);
      });
    } else {
      var id = rec.id,
          type = rec.type;
      return this.idToRecordKey(id, type);
    }
  };

  Normalizer.prototype.parseResObject = function (_a) {
    var _this = this;

    var id = _a.id,
        type = _a.type,
        attributes = _a.attributes,
        relationships = _a.relationships;
    var resource = {
      id: id,
      type: type
    };
    attributes && Object.assign(resource, attributes);

    if (relationships) {
      Object.keys(relationships).forEach(function (name) {
        var rel = relationships[name];
        resource[name + 'Key'] = _this.parseRelationships(rel);
      });
    }

    return resource;
  };

  Normalizer.prototype.parse = function (_a) {
    var _this = this;

    var _b = _a.data,
        included = _b.included,
        data = _b.data;

    if (included) {
      this.parse({
        data: {
          data: included
        }
      });
    }

    if (Array.isArray(data)) {
      return data.map(function (record) {
        return _this.parse({
          data: {
            data: record
          }
        });
      });
    }

    this.cache[this.idToRecordKey(data.id, data.type)] = this.parseResObject(data);
    return this.idToRecordKey(data.id, data.type);
  };

  Normalizer.prototype.parseErrors = function (_a) {
    var _b = _a.response.data.errors,
        errors = _b === void 0 ? [] : _b;
    return errors.map(function (e) {
      return e.detail;
    });
  };

  Normalizer.prototype.toJsonApi = function (record) {
    var _this = this;

    if (record === void 0) {
      record = {};
    }

    var obj = {
      id: record.id,
      type: record.type,
      attributes: {},
      relationships: {}
    };
    Object.keys(record).forEach(function (key) {
      if (key.slice(-3) === 'Key') {
        var rel = void 0;

        if (Array.isArray(record[key])) {
          rel = {
            data: record[key].map(_this.recordKeyToData)
          };
        } else {
          rel = {
            data: _this.recordKeyToData(record[key])
          };
        }

        obj.relationships[key.slice(0, -3)] = rel;
      } else if (!['id', 'type'].includes(key)) {
        obj.attributes[key] = record[key];
      }
    });
    return {
      data: obj
    };
  };

  return Normalizer;
}();

exports.default = Normalizer;